export default {
  data() {
    return {
      tabFocus: false,
    };
  },

  methods: {
    detectFocusChange() {
      let inView = false;

      this._onWindowFocusChange = (e) => {
        if ({ focus: 1, pageshow: 1 }[e.type]) {
          if (inView) return;
          this.tabFocus = true;
          inView = true;
        } else if (inView) {
          this.tabFocus = !this.tabFocus;
          inView = false;
        }
      };

      window.addEventListener("focus", this._onWindowFocusChange);
      window.addEventListener("blur", this._onWindowFocusChange);
      window.addEventListener("pageshow", this._onWindowFocusChange);
      window.addEventListener("pagehide", this._onWindowFocusChange);
    },
  },

  async created() {
    this.detectFocusChange();
  },

  beforeDestroy() {
    if (this._onWindowFocusChange) {
      window.removeEventListener("focus", this._onWindowFocusChange);
      window.removeEventListener("blur", this._onWindowFocusChange);
      window.removeEventListener("pageshow", this._onWindowFocusChange);
      window.removeEventListener("pagehide", this._onWindowFocusChange);
    }
  },
};
